import React, { useState, useEffect } from "react";
import { DatePicker } from "../../ui/date-picker";
import { Button } from '../../ui/button';
import { convertStartDatePickerTimeToMySQLTime } from "../../sharedfiles/helper";
import { useDispatch, useSelector, connect } from "react-redux";
import { getPlayer, updateplayer, setEditPlayerFormData } from "./PrimaryPlayerSlice";
import AuditLog from "./AuditLog";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../ui/dialog";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "../../ui/alert-dialog";
import { COMMON_CONSTANTS } from "../../sharedfiles/Constants";
import { PLAYER_MODULE } from "../../sharedfiles/tooltipMsgs";
import Tooltips from "../Common/Tooltip";

const EditPlayerDetails = (props) => {
  const dispatch = useDispatch();
  // Restores unsaved edits after closing and reopening this popup (it fully
  // unmounts/remounts each time - see PrimaryPlayer.js's `{openEditBox && ...}`)
  // - read once here and used only as lazy useState initializers below, so
  // the very first render already matches. Falls back to the player's
  // current saved values when there's no draft yet (first-ever open, or
  // right after a successful Save cleared it).
  const currentUserId = localStorage.getItem("userId");
  const rawEditPlayerFormData = useSelector((state) => state.primaryplayer.editPlayerFormData) || {};
  // Redux persists across this popup's unmount/remount by design, but also
  // across navigating to a DIFFERENT customer's profile - only trust the
  // draft when it was actually left for the customer currently being viewed,
  // otherwise a draft from one player leaks into another's popup.
  const editPlayerFormData = rawEditPlayerFormData.userId === currentUserId ? rawEditPlayerFormData : {};
  const seed = (key, fallback) => (key in editPlayerFormData ? editPlayerFormData[key] : fallback);

  const [firstName, setFirstName] = useState(() => seed("firstName", props.playerData.firstName));
  const [lastName, setLastName] = useState(() => seed("lastName", props.playerData.lastName));
  const [email, setEmail] = useState(() => seed("email", props?.playerData?.userOtherInfo?.email));
  const [dob, setDob] = useState(() => seed("dob", props.playerData.dob ? new Date(props.playerData.dob) : ""));
  const [selectedDob, setSelectedDob] = useState(() =>
    seed("selectedDob", props.playerData.dob ? new Date(props.playerData.dob) : "")
  );
  const [notification, setNotification] = useState(() => seed("notification", props?.playerData?.userCommPreference?.pushNotificationPhone));
  const [promotionEmail, setPromotionEmail] = useState(() => seed("promotionEmail", props?.playerData?.userCommPreference?.promotionalEmail));
  const [sms, setSms] = useState(() => seed("sms", props?.playerData?.userCommPreference?.sms));
  const [vip, setVip] = useState(() => seed("vip", props?.playerData?.vip));
  const [phoneCalls, setPhoneCalls] = useState(() => seed("phoneCalls", props?.playerData?.userCommPreference?.phoneCalls));
  const [keepLevel, setKeepLevel] = useState(() => seed("keepLevel", props?.playerData?.userOtherInfo?.keepLevelSticky));
  const [betDecision, setBetDecision] = useState(() => seed("betDecision", props?.playerData?.isBetDecision));
  const [dateError, setDateError] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [dobMsg, setDobMsg] = useState("");
  const [openAuditLog, setOpenAuditLog] = useState(false)
  const [userType, setUserType] = useState(() => seed("userType", props?.playerData.userType))
  const [userTypeErr, setUserTypeErr] = useState(false)
  const [btag, setBtag] = useState(() => seed("btag", props.playerData?.userOtherInfo?.affliateBtag))
  const [fraud, setFraud] = useState(false)
  const [realUser, setRealUser] = useState(false)

  const updateDetailsHandler = (event) => {
    setEmailError(false);
    const emailRegex =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const { name, value, checked } = event.target;
    if (name == "email") {
      setEmailError(false);
      setEmail(value);
      if (emailRegex.test(value)) {
      } else {
        setEmailError(true);
      }
    }
    if (name === "userType" && value === "FRAUD_USER") {
      setFraud(true)
    }
    if (name === "userType" && value === "REAL_USER") {
      setRealUser(true)
    }
    if (name === "userType" && value === "") {
      setUserTypeErr(true)
    } else {
      setUserTypeErr(false)
    }
    switch (name) {
      case "firstName":
        setFirstName(value);
        break;
      case "lastName":
        setLastName(value);
        break;
      //   case "email":
      //     setEmail(value);
      //     break;
      //   case "dob":
      //     setDob(event);
      //     break;
      case "notification":
        setNotification(checked);
        break;
      case "promotionEmail":
        setPromotionEmail(checked);
        break;
      case "sms":
        setSms(checked);
        break;
      case "vip":
        setVip(checked);
        break;
      case "phoneCalls":
        setPhoneCalls(checked);
        break;
      case "keepLevel":
        setKeepLevel(checked);
        break;
      case "betDecision":
        setBetDecision(checked);
        break;
      case "userType":
        setUserType(value);
        break;
      case "btag":
        setBtag(value)
        break;
      default:
        break;
    }
  };
  const validateAge = (e) => {
    e === null ? setDateError(true) : setDateError(false);
    e === null ? setDobMsg("dob cannot be empty") : setDateError("");
    var today = new Date();
    var birthDate = new Date(e);
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    if (age >= 18) {
      setDob(e);
      setSelectedDob(e);
    } else {
      setDob(e);
      setDobMsg("Age must be above 18");
      setSelectedDob(e);
      setDateError(true);
    }
  };

  const updateUser = () => {
    // const time = new Date().toTimeString();
    // const date = new Date(
    //   dob.setTime(dob.getTime() + dob.getTimezoneOffset() * 60 * 1000) + time
    // );
    let updateData = {
      dob: convertStartDatePickerTimeToMySQLTime(dob),
      firstName: firstName,
      lastName: lastName,
      email: email,
      phoneCalls: phoneCalls,
      promotionalEmail: promotionEmail,
      pushNotificationphone: notification,
      sms: sms,
      vip: vip,
      keepLevelSticky: keepLevel,
      isBetDecision: betDecision,
      userType: userType,
      affliateBtag: btag
    };
    if (userType === "") {
      setUserTypeErr(true)
    }
    const user_id = localStorage.getItem("userId")
    if (!userTypeErr && !dateError) {
      props.dispatch(
        updateplayer(localStorage.getItem("userId"), updateData)
      );
      setTimeout(() => dispatch(getPlayer({ user_id: user_id })), 300);
      // Clears the draft so the next open seeds fresh from the just-saved
      // playerData, instead of re-showing these now-stale local edits.
      dispatch(setEditPlayerFormData({}));
      props.setOpenEditBox(false);
    }
  };

  const onCloseFraud = () => {
    setFraud(false)
    setUserType(props?.playerData.userType)
  }
  const onCloseRealuser = () => {
    setRealUser(false)
    setUserType(props?.playerData.userType)
  }

  // Mirrors the persistable form fields into redux on every change, so
  // unsaved edits survive this popup closing and reopening.
  useEffect(() => {
    dispatch(setEditPlayerFormData({
      userId: currentUserId,
      firstName, lastName, email, dob, selectedDob, notification,
      promotionEmail, sms, vip, phoneCalls, keepLevel, betDecision,
      userType, btag,
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [firstName, lastName, email, dob, selectedDob, notification, promotionEmail, sms, vip, phoneCalls, keepLevel, betDecision, userType, btag]);

  return (
    <React.Fragment>
      <AuditLog
        openAuditLog={openAuditLog}
        setOpenAuditLog={setOpenAuditLog}
      />

      <AlertDialog open={realUser} onOpenChange={setRealUser}>
        <AlertDialogContent className="max-w-md">
          <AlertDialogHeader>
            <AlertDialogTitle className="text-lg">Activate User</AlertDialogTitle>
          </AlertDialogHeader>
          <p className="text-sm text-muted-foreground py-4">
            Are you sure you want to activate this user by changing the user type to "Real Player"?
          </p>
          <AlertDialogFooter className="gap-2">
            <AlertDialogCancel onClick={() => onCloseRealuser()} variant="outline">
              Cancel
            </AlertDialogCancel>
            <AlertDialogAction onClick={() => setRealUser(false)}>
              Continue
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
      <AlertDialog open={fraud} onOpenChange={setFraud}>
        <AlertDialogContent className="max-w-md">
          <AlertDialogHeader>
            <AlertDialogTitle className="text-lg text-destructive">Deactivate User</AlertDialogTitle>
          </AlertDialogHeader>
          <p className="text-sm text-muted-foreground py-4">
            Are you sure you want to deactivate this user by changing the user type to "Fraud User"? This action cannot be easily undone.
          </p>
          <AlertDialogFooter className="gap-2">
            <AlertDialogCancel onClick={() => onCloseFraud()} variant="outline">
              Cancel
            </AlertDialogCancel>
            <AlertDialogAction onClick={() => setFraud(false)} className="bg-destructive hover:bg-destructive/90">
              Deactivate
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>

      <Dialog open={props.openEditBox} onOpenChange={() => props.setOpenEditBox(false)}>
        <DialogContent className="max-w-3xl max-h-screen overflow-y-auto">
          <DialogHeader>
            <DialogTitle>Edit Player Details</DialogTitle>
          </DialogHeader>
          <div className='space-y-6'>
            {/* Personal Information Section */}
            <div className='space-y-4'>
              <h3 className='text-lg font-semibold text-foreground'>Personal Information</h3>
              <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
                {/* First Name */}
                <div className='space-y-2'>
                  <label className='flex items-center gap-2 text-sm font-medium text-foreground'>
                    {COMMON_CONSTANTS.header_firstname}
                    <Tooltips info={PLAYER_MODULE.firstName} />
                  </label>
                  <input
                    type='text'
                    name='firstName'
                    id='editplayerfirstname'
                    placeholder='Enter first name'
                    value={firstName}
                    onChange={updateDetailsHandler}
                    className="w-full px-3 py-2 border border-input rounded-md bg-background focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2"
                  />
                </div>

                {/* Last Name */}
                <div className='space-y-2'>
                  <label className='flex items-center gap-2 text-sm font-medium text-foreground'>
                    {COMMON_CONSTANTS.header_lastname}
                    <Tooltips info={PLAYER_MODULE.LastName} />
                  </label>
                  <input
                    type='text'
                    name='lastName'
                    id='editplayerlastname'
                    value={lastName}
                    onChange={updateDetailsHandler}
                    placeholder='Enter last name'
                    className="w-full px-3 py-2 border border-input rounded-md bg-background focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2"
                  />
                </div>

                {/* Email */}
                <div className='space-y-2'>
                  <label className='flex items-center gap-2 text-sm font-medium text-foreground'>
                    {COMMON_CONSTANTS.header_Email}
                    <Tooltips info={PLAYER_MODULE.Email} />
                  </label>
                  <input
                    type='email'
                    name='email'
                    value={email}
                    onChange={updateDetailsHandler}
                    placeholder='example@gmail.com'
                    autoComplete='off'
                    className="w-full px-3 py-2 border border-input rounded-md bg-background focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2"
                  />
                  {emailError && <p className='text-xs text-destructive font-medium'>Enter a valid email address</p>}
                </div>

                {/* Date of Birth */}
                <div className='space-y-2'>
                  <label className='flex items-center gap-2 text-sm font-medium text-foreground'>
                    {COMMON_CONSTANTS.header_dob}
                    <Tooltips info={PLAYER_MODULE.Edit_DOB} />
                  </label>
                  <DatePicker
                    name='dateOfBirth'
                    placeholder={"DD/MM/YYYY"}
                    value={dob}
                    setValue={(v) => validateAge(v)}
                    inline
                  />
                  {dateError && <p className='text-xs text-destructive font-medium'>{dobMsg}</p>}
                </div>

                {/* User Type */}
                <div className='space-y-2'>
                  <label className='flex items-center gap-2 text-sm font-medium text-foreground'>
                    User Type
                    <Tooltips info={PLAYER_MODULE.Edit_Usertype} />
                  </label>
                  <select
                    id='userType'
                    name='userType'
                    value={userType}
                    onChange={updateDetailsHandler}
                    className="w-full px-3 py-2 border border-input rounded-md bg-background focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 cursor-pointer"
                  >
                    <option value=''>Select User Type</option>
                    <option value='REAL_USER'>Real Player</option>
                    <option value='TEST_USER'>Test User</option>
                    <option value='FRAUD_USER'>Fraud User</option>
                  </select>
                  {userTypeErr && <p className='text-xs text-destructive font-medium'>User Type is required</p>}
                </div>

                {/* Btag */}
                <div className='space-y-2'>
                  <label className='flex items-center gap-2 text-sm font-medium text-foreground'>
                    Btag
                    <Tooltips info={PLAYER_MODULE.Btag} />
                  </label>
                  <input
                    type='text'
                    name='btag'
                    id='editplayerbtag'
                    placeholder='Enter Btag'
                    value={btag}
                    onChange={updateDetailsHandler}
                    className="w-full px-3 py-2 border border-input rounded-md bg-background focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2"
                  />
                </div>
                {/* VIP Checkbox */}
                <div className='flex items-center space-x-2 p-3 rounded-md border border-input hover:bg-accent transition-colors'>
                  <input
                    id='vip'
                    type='checkbox'
                    name='vip'
                    onChange={updateDetailsHandler}
                    checked={vip}
                    className='w-4 h-4 rounded border-input cursor-pointer'
                  />
                  <label htmlFor='vip' className='text-sm font-medium text-foreground cursor-pointer'>
                    {COMMON_CONSTANTS.header_VIP}
                  </label>
                </div>
                {/* Keep Level Checkbox */}
                <div className='flex items-center space-x-2 p-3 rounded-md border border-input hover:bg-accent transition-colors'>
                  <input
                    id='keeplevel'
                    type='checkbox'
                    name='keepLevel'
                    checked={keepLevel}
                    onChange={updateDetailsHandler}
                    className='w-4 h-4 rounded border-input cursor-pointer'
                  />
                  <label htmlFor='keeplevel' className='text-sm font-medium text-foreground cursor-pointer'>
                    {COMMON_CONSTANTS.keepLevelSticky}
                  </label>
                </div>
                <div className='flex items-center space-x-2 p-3 rounded-md border border-input hover:bg-accent transition-colors'>
                  <input
                    id='betDecision'
                    type='checkbox'
                    name='betDecision'
                    checked={betDecision}
                    onChange={updateDetailsHandler}
                    className='w-4 h-4 rounded border-input cursor-pointer'
                  />
                  <label htmlFor='betDecision' className='text-sm font-medium text-foreground cursor-pointer'>
                    {COMMON_CONSTANTS.betDecision}
                  </label>
                </div>
              </div>
            </div>

            {/* Communication Preferences Section */}
            <div className='space-y-4 border-t pt-6'>
              <h3 className='text-lg font-semibold text-foreground'>Communication Preferences</h3>
              <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4'>
                {/* Notification Checkbox */}
                <div className='flex items-center space-x-2 p-3 rounded-md border border-input hover:bg-accent transition-colors'>
                  <input
                    id='notification'
                    type='checkbox'
                    name='notification'
                    checked={notification}
                    onChange={updateDetailsHandler}
                    className='w-4 h-4 rounded border-input cursor-pointer'
                  />
                  <label htmlFor='notification' className='text-sm font-medium text-foreground cursor-pointer'>
                    {COMMON_CONSTANTS.header_notification}
                  </label>
                </div>

                {/* Promotion Email Checkbox */}
                <div className='flex items-center space-x-2 p-3 rounded-md border border-input hover:bg-accent transition-colors'>
                  <input
                    id='promotionEmail'
                    type='checkbox'
                    name='promotionEmail'
                    checked={promotionEmail}
                    onChange={updateDetailsHandler}
                    className='w-4 h-4 rounded border-input cursor-pointer'
                  />
                  <label htmlFor='promotionEmail' className='text-sm font-medium text-foreground cursor-pointer'>
                    {COMMON_CONSTANTS.header_promoEmail}
                  </label>
                </div>

                {/* SMS Checkbox */}
                <div className='flex items-center space-x-2 p-3 rounded-md border border-input hover:bg-accent transition-colors'>
                  <input
                    id='sms'
                    type='checkbox'
                    name='sms'
                    checked={sms}
                    onChange={updateDetailsHandler}
                    className='w-4 h-4 rounded border-input cursor-pointer'
                  />
                  <label htmlFor='sms' className='text-sm font-medium text-foreground cursor-pointer'>
                    {COMMON_CONSTANTS.header_sms}
                  </label>
                </div>

                {/* Phone Calls Checkbox */}
                <div className='flex items-center space-x-2 p-3 rounded-md border border-input hover:bg-accent transition-colors'>
                  <input
                    id='phonecall'
                    type='checkbox'
                    name='phoneCalls'
                    checked={phoneCalls}
                    onChange={updateDetailsHandler}
                    className='w-4 h-4 rounded border-input cursor-pointer'
                  />
                  <label htmlFor='phonecall' className='text-sm font-medium text-foreground cursor-pointer'>
                    {COMMON_CONSTANTS.header_phnCalls}
                  </label>
                </div>
              </div>
            </div>

            {/* Action Buttons */}
            <div className='flex flex-wrap gap-3 border-t pt-6 justify-end'>
              <Button
                onClick={() => setOpenAuditLog(true)}
                type='button'
                id='editplayerAudit'
                variant="outline"
              >
                {COMMON_CONSTANTS.auditLogBtn}
              </Button>
              <Button
                onClick={() => props.setOpenEditBox(false)}
                type='button'
                id='editplayercancel'
                variant="outline"
              >
                {COMMON_CONSTANTS.cancel}
              </Button>
              <Button
                onClick={updateUser}
                type='button'
                id='editplayersave'
              >
                {COMMON_CONSTANTS.save}
              </Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
};
const mapStateToProps = (state) => {
  return {
    playerData: state.primaryplayer.playerData,
  };
};
export default connect(mapStateToProps)(EditPlayerDetails);